import { ReportRecord } from '../../models/report.model';

export function rouletter(colourPaletter) {
  let index = 0;
  return {
    reset: () => (index = 0),
    next: () => {
      if (index < colourPaletter.length - 1) {
        return colourPaletter[index++];
      }
      index = 0;
      return colourPaletter[colourPaletter.length - 1];
    },
  };
}

export const miqColorRoulette = rouletter([
  'image-container default',
  'image-container blue',
  'image-container yellow',
  'image-container orange',
  'image-container red',
  'image-container pink',
  'image-container purple',
  'image-container green',
]);

/**
 * Commonly used on report views. Receives a list of records and maps a color to
 * the record object.
 *
 * @param reportItems Items to map
 */
export function mapImageColorToRecordItems(reportItems: ReportRecord[]) {
  miqColorRoulette.reset();
  return reportItems.map(({ data, associatedProperty, ...reportItem }) => {
    const color = miqColorRoulette.next();
    const mappedReportItem = {
      ...reportItem,
      data: Array.isArray(data) ? data.map(recordData => ({ ...recordData, color })) : { ...data, color },
    } as any;

    // `if` added due to function returning an object with an one-property
    // associatedProperty object when original associatedProperty was null
    if (!!associatedProperty) {
      mappedReportItem.associatedProperty = { ...associatedProperty, color };
    }
    return mappedReportItem;
  });
}
